import { Content, Title } from '@/ev/styles';
import TrackWrapper from '~/components/common/TrackWrapper';
import { appAssetsCdnUrl } from '~/constants/environment';
import { useDeviceType } from '~/context/common/DeviceContext';
import {
  ContentWrapper,
  IconImg,
  IconWrapper,
  ImageWrapper,
  SectionImg,
  SectionWrapper
} from './FindingEv.styles';
import findingEvData from './FindingEvData';

const EvLifestyleImage = ({ className = '' }) => {
  const { isDesktop } = useDeviceType();
  const imgUrl = isDesktop
    ? '/images/ev-lifestyle-desktop.png'
    : '/images/ev-lifestyle.png';

  return (
    <ImageWrapper className={className}>
      <IconWrapper>
        <IconImg src={`${appAssetsCdnUrl}/svgs/ev-plug.svg`} alt="" />
      </IconWrapper>
      <SectionImg
        src={`${appAssetsCdnUrl}${imgUrl}`}
        alt="Person charging an electric vehicle in a driveway"
      />
    </ImageWrapper>
  );
};

export default function FindingEv() {
  return (
    <TrackWrapper event={{ eventName: 'Viewed - Finding an Ev' }}>
      <SectionWrapper>
        <EvLifestyleImage className="hidden md:block md:h-[590px]" />
        <div>
          <Title className="mb-xl sm:mb-2xl">
            Finding a used EV that suits your lifestyle
          </Title>
          <Content className="md:mb-3xl">
            Ensuring your used EV matches your lifestyle is just as important as
            getting a good deal. Here are a couple of things to look into:
          </Content>
          <EvLifestyleImage className="md:hidden" />
          <div className="flex flex-col gap-2xl sm:gap-3xl md:gap-2xl">
            {findingEvData.map(({ title, content: ListContent }) => {
              return (
                <ContentWrapper key={title}>
                  <p className="text-text-strong t-heading-lg">{title}</p>
                  <ListContent />
                </ContentWrapper>
              );
            })}
          </div>
        </div>
      </SectionWrapper>
    </TrackWrapper>
  );
}
